<template>
  <div class="col-md-12 job-card">
    <div class="table-responsive">
      <p>Working Experience</p>
      <div class="active d-flex justify-content-between flex-wrap">
        <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in app.applicant.applicantExperiences"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a href="#/" class="name">{{
                                  item.companyName
                                }}</a>
                                <div>{{ item.position }}</div>
                                <span class="time"
                                  >{{ new Date(item.startYear).toLocaleString('default', { month: 'short' })}} {{new Date(item.startYear).getFullYear() }} -
                                  {{ new Date(item.endYear).toLocaleString('default', { month: 'short' })}} {{new Date(item.endYear).getFullYear() }}</span
                                >
                                <hr />
                                <span>{{ item.description}}</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "experience-card",
  props: {
    app: {},
    currentOffice: {}
  },
};
</script>



// WEBPACK FOOTER //
// src/components/applications/working-experience-card.vue